import { useI18n } from '@/shared/i18n/I18nProvider'

/**
 * WHO BUILT THIS, in the smallest type the product sets.
 *
 * It stands at the very bottom of both frames — the foot under the workspace
 * and the foot of the sign-in card — because a credit is the last thing on a
 * page, not something competing with the work on it. `--text-2xs` and
 * `--text-faint` are the floor of the type scale and the quietest ink in the
 * contract, which is the whole intended register: present on every screen,
 * legible when looked for, invisible while working.
 *
 * IT IS NOT A LINK YET. A credit that goes somewhere needs a destination the
 * product is willing to send a clinician's browser to, and none has been
 * given; a guessed URL in the shell of a clinical system is worse than no URL.
 * When one arrives this becomes an `<a>` and nothing else here changes.
 *
 * THE NAME IS A `bdi`, and it is the reason the line is composed from two
 * messages rather than written as one. `Mislab IL` is Latin, the Hebrew
 * catalogue's words around it are not, and a Latin run inside RTL prose is
 * exactly the case the bidi algorithm reorders around whatever follows it. The
 * isolate makes the name one opaque piece, so it reads the same in all three
 * languages — the same treatment the shell gives a clinic's name.
 *
 * The credit is BRAND-INDEPENDENT on purpose: a white-label appearance changes
 * whose product the clinician is using, never who wrote it.
 */
export function DeveloperCredit() {
  const { t } = useI18n()
  return (
    <p className="brand-credit">
      {t('app.developedBy')} <bdi className="brand-credit__developer">{t('app.developer')}</bdi>
    </p>
  )
}
